import { InjectionToken } from '@angular/core';
import { AppPermissionsSettings } from '../../auth/services/app-permissions-settings';

export const APP_PERMISSIONS = new InjectionToken<AppPermissionsSettings>('APP_PERMISSIONS');
